import type { ReviewMomentReference, TimeControl } from "@chessla/shared";

export { gameReviewUrl } from "@/shared/game-review-url";

export const readNikolaDraft = (
  state: unknown,
  ownerUserId: string | null,
): { draft: string; format: TimeControl } | null => {
  if (!state || typeof state !== "object" || !("nikolaDraft" in state)) return null;
  const value = state.nikolaDraft;
  if (!value || typeof value !== "object" || !("draft" in value) || !("format" in value)) return null;
  if (!ownerUserId || !("ownerUserId" in value) || value.ownerUserId !== ownerUserId) return null;
  if (typeof value.draft !== "string" || !value.draft.trim() || value.draft.length > 4000) return null;
  if (value.format !== "rapid" && value.format !== "blitz" && value.format !== "bullet" && value.format !== "daily")
    return null;
  return { draft: value.draft, format: value.format };
};

export const resolveHandoffDraft = (
  stored: string | null,
  current: string,
  suggestion: string,
  touched: boolean,
): string => stored ?? (touched ? current : suggestion);

export const nikolaReviewHandoffUrl = (reference: ReviewMomentReference): string => {
  const query = new URLSearchParams({ new: "1", gameId: reference.gameId, factId: reference.factId });
  return `/chat?${query.toString()}`;
};

export const nikolaSettingsUrl = "/settings?section=nikola#nikola-data-heading";
